import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, Input, OnInit, output } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import type { IObjectCollection } from "@nova/common-interfaces";
import {
  createEmptyObjectCollection,
  IComment,
  isObjectCollection,
} from "@nova/common-interfaces";
import { CommonComponent } from "../../common/common.component.mjs";

@Component({
    selector: "app-common-comments-card",
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    templateUrl: "./comment-card.component.html",
    styleUrls: ["./comment-card.component.scss"]
})
export class CommonCommentsCard extends CommonComponent implements OnInit, AfterViewInit{
  // #region Properties (7)

  @Input()
  public canEdit = false;
  @Input()
  public comments: IObjectCollection<IComment> =
    createEmptyObjectCollection<IComment>();
  public commentsChanged = output<IObjectCollection<IComment>>();
  public createComment = false;
  public newComment: IComment = {} as IComment;
  public newRow = false;
  public rowEdit = -1;
  public override hasData = false;

  // #endregion Properties (7)

  // #region Constructors (1)

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    if (isObjectCollection(this.comments) &&
     Array.isArray(this.comments.data))
    {
      if (this.comments.data.length > 0)
      {
        this.hasData = true;
      }
    }
  }

  // #endregion Constructors (1)

  // #region Public Methods (4)

  public addComment(event: any) {
    this.newComment.createdAt = Date.now();
    this.createComment = true;
  }

  public cancelComment() {
    this.createComment = false;
    this.rowEdit = -1;
    if (this.newRow) {
      this.comments.data.splice(this.comments.length - 1, 1);
    }
  }

  public ngOnInit() {}

  public saveComment() {
    this.comments.data.push({ ...this.newComment } as IComment);
    this.comments.length = this.comments.data.length;
    this.commentsChanged.emit(this.comments);
    this.newComment = {} as IComment;
    this.createComment = false;
  }

  // #endregion Public Methods (4)
}
